import React, { useEffect, useRef, useState, useCallback } from "react";
import { API, graphqlOperation } from 'aws-amplify';
import { listSpotJDS } from '../../graphql/queries';
import { updateSpotJD, createSpotCandidateStatus } from '../../graphql/mutations';
import arrow from "../../assets/Arrow.svg";
import zoom from "../../assets/view.svg";
import logo from "../../assets/Copy of classic.gif";
import "../Company/SpotGPT.css";
import { MdOutlineWatchLater } from "react-icons/md";
import { FiSearch, FiMenu, FiChevronDown, FiChevronUp, FiPlus, FiSettings, FiMessageSquare, FiHelpCircle, FiTrash2, FiRefreshCw } from "react-icons/fi";
import profile from "../../assets/profile.png"
import { Flex } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import { 
  startSession,
  listSessions,
  getSessionMessages,
  deleteSession as deleteSessionAPI,
  sendChatMessageStreaming,
  formatMarkdown,
  extractTopic,
  truncateText,
  isAtSessionLimit
} from '../../utils/spotGptService';
import MCPSettingsModal from '../../components/company/MCPSettingsModal';

// API Base URL for matching and knowledge graph services
const API_BASE_URL = 'https://phone.getscreened.in/api';

// Mode-based suggestion questions
const modeSuggestions = {
  normal: [
    "Find Python developers",
    "Show me candidates with 5+ years experience",
    "Show me candidates in Pune",
    "Search for candidates with Java skills"
  ],
  advanced: [
    "How many DevOps engineers do we have?",
    "Find the best candidates for a Senior Data Scientist role",
    "Show me our talent distribution patterns",
    "Analyze skill gaps in our database"
  ],
  spot: [
    "Show me candidates for this role",
    "Get candidate details",
    "Display the candidate pipeline",
    "What are the job requirements?"
  ]
};

function SpotGPT() {
  const [inputValue, setInputValue] = useState("");
  const [response, setResponse] = useState("");

  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [isRightSectionVisible, setIsRightSectionVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("JD Base");
  const [zoomleft, setZoomleft] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [candidatelist, setCandidatelist] = useState([])
  const [candidateSource, setCandidateSource] = useState([])
  const navigate = useNavigate()

  // New states for chat.html features
  const [conversations, setConversations] = useState([]);
  const [currentConversation, setCurrentConversation] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [availableJDs, setAvailableJDs] = useState([]);
  const [selectedJD, setSelectedJD] = useState(null);
  const [isJDSelectorOpen, setIsJDSelectorOpen] = useState(false);
  const [isModeDropdownOpen, setIsModeDropdownOpen] = useState(false);
  const [mode, setMode] = useState('normal'); // 'normal', 'advanced', 'spot'
  const [isQuickActionsOpen, setIsQuickActionsOpen] = useState(false);
  
  // Video modal states
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState({ url: '', skill: '', candidateName: '' });
  
  // MCP Settings modal state
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
  
  const [currentSuggestions, setCurrentSuggestions] = useState(modeSuggestions.normal);

  // Session Management States (NEW)
  const [currentSessionId, setCurrentSessionId] = useState(null);
  const [messageCount, setMessageCount] = useState(0);
  const [remainingMessages, setRemainingMessages] = useState(20);
  const [isLoadingSessions, setIsLoadingSessions] = useState(false);
  const [isStreaming, setIsStreaming] = useState(false);
  const [streamingContent, setStreamingContent] = useState('');
  const [currentToolName, setCurrentToolName] = useState(null);
  const [showSessionLimitModal, setShowSessionLimitModal] = useState(false);
  const [companyEmail, setCompanyEmail] = useState('');

  // Quick Actions states
  const [matchedCandidatesFromEngine, setMatchedCandidatesFromEngine] = useState([]);
  const [isRunningMatching, setIsRunningMatching] = useState(false);
  const [matchingResult, setMatchingResult] = useState(null);
  const [selectCandidateEmail, setSelectCandidateEmail] = useState('');
  const [selectRoundNumber, setSelectRoundNumber] = useState(1);
  const [selectNotes, setSelectNotes] = useState('');
  const [filterCandidateEmail, setFilterCandidateEmail] = useState('');
  const [filterReason, setFilterReason] = useState('');
  const [isProcessingSelect, setIsProcessingSelect] = useState(false);
  const [isProcessingFilter, setIsProcessingFilter] = useState(false);
  const [actionResult, setActionResult] = useState({ type: '', message: '' });
  const [autoFilterEnabled, setAutoFilterEnabled] = useState(false); // Default: false
  const [selectedMatchingCandidates, setSelectedMatchingCandidates] = useState([]); // For manual selection

  const [candidates, setCandidates] = useState([
    {
      id: 1,
      name: "John Doe 1",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      skills: ["HTML", "CSS", "JS"],
    },
    {
      id: 2,
      name: "John Doe 2",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      skills: ["HTML", "CSS", "JS"],
    },
    {
      id: 3,
      name: "John Doe 3",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      skills: ["HTML", "CSS", "JS"],
    },
    {
      id: 4,
      name: "John Doe 4",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      skills: ["HTML", "CSS", "JS"],
    },
    {
      id: 5,
      name: "Multiple Candidates",
      description: "Click view more to see sub-candidates.",
      profiles: [
        {
          id: 6,
          name: "Bone Doe",
          imgSrc: "#",
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
          skills: ["React", "Node.js"],
        },
        {
          id: 7,
          name: "Jim Doe",
          imgSrc: "#",
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
          skills: ["Angular", "TypeScript"],
        },
        {
          id: 8,
          name: "Jake Doe",
          imgSrc: "#",
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
          skills: ["Vue", "JavaScript"],
        },
      ],
    },
  ]);

  // const handleKeyDown = (event) => {
  //   console.log("ddddd", event);
  //   if (event.type == "click") {

  //     console.log("called");
  //     setResponse("How are you?");

  //     console.log("typesd:", inputValue);
  //   }
  // };

  const handleKeyDown = () => {
    if (inputValue) {
      setInputValue(inputValue); // Clear the input field after submission
      setIsSubmitted(true); // Show the prompt
      setResponse("How are you?");
    }
  };

  const handleAddToSelectedCandidates = (candidate) => {
    if (!selectedCandidates.includes(candidate)) {
      setSelectedCandidates([...selectedCandidates, candidate]);
      setIsRightSectionVisible(true);
    }
  };

  const handleRemoveCandidate = (candidate) => {
    const updatedCandidates = selectedCandidates.filter(
      (c) => c.id !== candidate.id
    );
    setSelectedCandidates(updatedCandidates);
    if (updatedCandidates.length === 0) {
      setIsRightSectionVisible(false);
    }
  };

  const handlezoom = () => {
    setZoomleft(!zoomleft);
  };
  const handleViewMore = (id) => {
    const expandedProfiles = candidates
      .find((candidate) => candidate.id === id)
      .profiles.map((profile, idx) => ({
        ...profile,
        id: candidates.length + idx + 1,
      }));

    // Remove the original id 4 candidate and add the expanded profiles
    setCandidates((prevCandidates) => {
      const candidateToRemove = prevCandidates.find(
        (candidate) => candidate.id === id
      );

      // Add expanded profiles and ensure they include the removed candidate (if needed)
      return prevCandidates
        .filter((candidate) => candidate.id !== id) // Remove the candidate with the original id 4
        .concat(expandedProfiles); // Add the expanded profiles, which could include the updated candidate
    });
  };

  // ===== Quick Actions API Functions =====

  // Run matching engine for selected JD
  const runMatchingEngine = async () => {
    if (!selectedJD) {
      setActionResult({ type: 'error', message: 'Please select a JD first' });
      return;
    }

    setIsRunningMatching(true);
    setMatchingResult(null);
    setActionResult({ type: '', message: '' });
    setSelectedMatchingCandidates([]); // Reset selection

    try {
      // selectedJD.id is already the SpotJD ID from listSpotJDS
      const response = await fetch(`${API_BASE_URL}/matching/match-candidates`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ job_id: selectedJD.id })
      });

      if (!response.ok) {
        throw new Error('Failed to run matching engine');
      }

      const data = await response.json();
      const candidates = data.candidates || data.matched_candidates || data.results || [];
      
      setMatchedCandidatesFromEngine(candidates);
      setMatchingResult({
        total: candidates.length,
        qualified: candidates.filter(c => c.qualified).length
      });
      
      // Only auto-filter if enabled (default is false)
      if (candidates.length > 0 && autoFilterEnabled) {
        await autoFilterMatchedCandidates(selectedJD.id, candidates);
        setActionResult({ 
          type: 'success', 
          message: `Found ${candidates.length} matching candidates. All auto-filtered.` 
        });
      } else {
        setActionResult({ 
          type: 'success', 
          message: `Found ${candidates.length} matching candidates. Select candidates to filter or add to screening.` 
        });
      }
      
      console.log('✅ Matching engine results:', data);
    } catch (error) {
      console.error('❌ Error running matching engine:', error);
      setActionResult({ type: 'error', message: error.message });
    } finally {
      setIsRunningMatching(false);
    }
  };

  // Toggle individual candidate selection
  const toggleMatchingCandidateSelection = (candidate) => {
    const email = candidate.email || candidate.candidate_email;
    setSelectedMatchingCandidates(prev => {
      const isSelected = prev.some(c => (c.email || c.candidate_email) === email);
      if (isSelected) {
        return prev.filter(c => (c.email || c.candidate_email) !== email);
      } else {
        return [...prev, candidate];
      }
    });
  };

  // Select all matching candidates
  const selectAllMatchingCandidates = () => {
    setSelectedMatchingCandidates([...matchedCandidatesFromEngine]);
  };

  // Deselect all matching candidates  
  const deselectAllMatchingCandidates = () => {
    setSelectedMatchingCandidates([]);
  };

  // Filter selected candidates manually
  const filterSelectedMatchingCandidates = async () => {
    if (!selectedJD || selectedMatchingCandidates.length === 0) {
      setActionResult({ type: 'error', message: 'Please select at least one candidate to filter' });
      return;
    }

    setIsRunningMatching(true);
    try {
      await autoFilterMatchedCandidates(selectedJD.id, selectedMatchingCandidates);
      
      // Mark as filtered in UI
      setMatchedCandidatesFromEngine(prev => prev.map(c => {
        const email = c.email || c.candidate_email;
        const isFiltered = selectedMatchingCandidates.some(sc => (sc.email || sc.candidate_email) === email);
        return isFiltered ? { ...c, isFiltered: true } : c;
      }));
      
      setActionResult({ 
        type: 'success', 
        message: `Successfully filtered ${selectedMatchingCandidates.length} candidates!` 
      });
      setSelectedMatchingCandidates([]);
    } catch (error) {
      console.error('❌ Error filtering candidates:', error);
      setActionResult({ type: 'error', message: error.message });
    } finally {
      setIsRunningMatching(false);
    }
  };

  // Select candidates for screening
  const selectMatchingCandidatesForScreening = async () => {
    if (!selectedJD || selectedMatchingCandidates.length === 0) {
      setActionResult({ type: 'error', message: 'Please select at least one candidate for screening' });
      return;
    }

    setIsRunningMatching(true);
    try {
      const companyEmail = localStorage.getItem("CompanyEmailID");
      
      for (const candidate of selectedMatchingCandidates) {
        const email = candidate.email || candidate.candidate_email;
        
        // Get current SpotJD
        const spotJDResponse = await API.graphql(
          graphqlOperation(listSpotJDS, {
            filter: { id: { eq: selectedJD.id } }
          })
        );
        const spotJD = spotJDResponse.data.listSpotJDS.items[0];
        
        if (spotJD) {
          // Update selectedCandidate array
          let existingSelected = [];
          try {
            existingSelected = JSON.parse(spotJD.selectedCandidate || '[]');
          } catch (e) {
            existingSelected = [];
          }
          
          if (!existingSelected.includes(email)) {
            existingSelected.push(email);
            await API.graphql({
              query: updateSpotJD,
              variables: {
                input: {
                  id: selectedJD.id,
                  selectedCandidate: JSON.stringify(existingSelected)
                }
              }
            });
          }
        }

        // Create status record
        try {
          await API.graphql({
            query: createSpotCandidateStatus,
            variables: {
              input: {
                spotJdID: selectedJD.id,
                companyEmail: companyEmail,
                candidateEmail: email,
                roundStatus: 'selected',
                isEmailsend: false,
                selectionFlag: 'selected',
                candidateFrom: 'matching_engine'
              }
            }
          });
        } catch (e) {
          console.warn('Status record may already exist:', email);
        }

        // Call select-candidate API with SpotJD ID
        try {
          await fetch(`${API_BASE_URL}/kg/spot/select-candidate`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              jd_id: selectedJD.id,
              candidate_email: email,
              round_number: 1,
              notes: 'Selected from matching engine'
            })
          });
        } catch (e) {
          console.warn('Graph DB select failed for:', email);
        }
      }

      // Mark as selected in UI
      setMatchedCandidatesFromEngine(prev => prev.map(c => {
        const email = c.email || c.candidate_email;
        const isSelected = selectedMatchingCandidates.some(sc => (sc.email || sc.candidate_email) === email);
        return isSelected ? { ...c, isSelected: true } : c;
      }));
      
      setActionResult({ 
        type: 'success', 
        message: `Successfully selected ${selectedMatchingCandidates.length} candidates for screening!` 
      });
      setSelectedMatchingCandidates([]);
    } catch (error) {
      console.error('❌ Error selecting candidates:', error);
      setActionResult({ type: 'error', message: error.message });
    } finally {
      setIsRunningMatching(false);
    }
  };

  // Auto-filter all matched candidates (from matching engine)
  const autoFilterMatchedCandidates = async (jdId, candidates) => {
    try {
      // Get current SpotJD
      const spotJDResponse = await API.graphql(
        graphqlOperation(listSpotJDS, {
          filter: { id: { eq: jdId } }
        })
      );
      
      const spotJD = spotJDResponse.data.listSpotJDS.items[0];
      if (!spotJD) return;

      // Get existing filtered candidates
      let existingFiltered = [];
      try {
        existingFiltered = JSON.parse(spotJD.filterCandidate || '[]');
      } catch (e) {
        existingFiltered = [];
      }

      // Add new candidates to filtered list
      const newEmails = candidates.map(c => c.email || c.candidate_email);
      const allFiltered = [...new Set([...existingFiltered, ...newEmails])];

      // Update SpotJD
      await API.graphql({
        query: updateSpotJD,
        variables: {
          input: {
            id: jdId,
            filterCandidate: JSON.stringify(allFiltered)
          }
        }
      });

      // Create SpotCandidateStatus for each and call filter API
      const companyEmail = localStorage.getItem("CompanyEmailID");
      for (const candidate of candidates) {
        const email = candidate.email || candidate.candidate_email;
        
        // Create status record
        try {
          await API.graphql({
            query: createSpotCandidateStatus,
            variables: {
              input: {
                spotJdID: jdId,
                companyEmail: companyEmail,
                candidateEmail: email,
                roundStatus: 'filtered',
                isEmailsend: false,
                selectionFlag: 'filtered',
                candidateFrom: 'matching_engine'
              }
            }
          });
        } catch (e) {
          console.warn('Status record may already exist:', email);
        }

        // Call filter-candidate API
        try {
          await fetch(`${API_BASE_URL}/kg/spot/filter-candidate`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              jd_id: jdId,
              candidate_email: email,
              round_number: 1,
              notes: 'Filtered from matching engine'
            })
          });
        } catch (e) {
          console.warn('Graph DB filter failed for:', email);
        }
      }

      console.log('✅ Auto-filtered', candidates.length, 'candidates');
    } catch (error) {
      console.error('❌ Error auto-filtering candidates:', error);
    }
  };

  // Select candidate - triggers private screening flow
  const handleSelectCandidate = async () => {
    if (!selectedJD) {
      setActionResult({ type: 'error', message: 'Please select a JD first' });
      return;
    }
    if (!selectCandidateEmail.trim()) {
      setActionResult({ type: 'error', message: 'Please enter candidate email' });
      return;
    }

    setIsProcessingSelect(true);
    setActionResult({ type: '', message: '' });

    try {
      // Get SpotJD
      const spotJDResponse = await API.graphql(
        graphqlOperation(listSpotJDS, {
          filter: { id: { eq: selectedJD.id } }
        })
      );
      
      const spotJD = spotJDResponse.data.listSpotJDS.items[0];
      if (!spotJD) {
        throw new Error('SpotJD not found');
      }

      // Update selectedCandidate array in SpotJD
      let existingSelected = [];
      try {
        existingSelected = JSON.parse(spotJD.selectedCandidate || '[]');
      } catch (e) {
        existingSelected = [];
      }

      if (!existingSelected.includes(selectCandidateEmail)) {
        existingSelected.push(selectCandidateEmail);
      }

      await API.graphql({
        query: updateSpotJD,
        variables: {
          input: {
            id: selectedJD.id,
            selectedCandidate: JSON.stringify(existingSelected)
          }
        }
      });

      // Create SpotCandidateStatus record
      const companyEmail = localStorage.getItem("CompanyEmailID");
      try {
        await API.graphql({
          query: createSpotCandidateStatus,
          variables: {
            input: {
              spotJdID: selectedJD.id,
              companyEmail: companyEmail,
              candidateEmail: selectCandidateEmail,
              roundStatus: 'selected',
              isEmailsend: false,
              selectionFlag: 'selected',
              candidateFrom: 'quick_action'
            }
          }
        });
      } catch (e) {
        console.warn('Status record may already exist');
      }

      // Call select-candidate API for Graph DB
      await fetch(`${API_BASE_URL}/kg/spot/select-candidate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          jd_id: selectedJD.id,
          candidate_email: selectCandidateEmail,
          round_number: selectRoundNumber,
          notes: selectNotes || 'Selected via Quick Actions'
        })
      });

      setActionResult({ 
        type: 'success', 
        message: `✅ ${selectCandidateEmail} selected successfully! Added to SpotJD and Graph DB.` 
      });

      // Clear form
      setSelectCandidateEmail('');
      setSelectNotes('');
      setSelectRoundNumber(1);

      console.log('✅ Candidate selected:', selectCandidateEmail);
    } catch (error) {
      console.error('❌ Error selecting candidate:', error);
      setActionResult({ type: 'error', message: error.message });
    } finally {
      setIsProcessingSelect(false);
    }
  };

  // Filter candidate
  const handleFilterCandidate = async () => {
    if (!selectedJD) {
      setActionResult({ type: 'error', message: 'Please select a JD first' });
      return;
    }
    if (!filterCandidateEmail.trim()) {
      setActionResult({ type: 'error', message: 'Please enter candidate email' });
      return;
    }

    setIsProcessingFilter(true);
    setActionResult({ type: '', message: '' });

    try {
      // Get SpotJD
      const spotJDResponse = await API.graphql(
        graphqlOperation(listSpotJDS, {
          filter: { id: { eq: selectedJD.id } }
        })
      );
      
      const spotJD = spotJDResponse.data.listSpotJDS.items[0];
      if (!spotJD) {
        throw new Error('SpotJD not found');
      }

      // Update filterCandidate array in SpotJD
      let existingFiltered = [];
      try {
        existingFiltered = JSON.parse(spotJD.filterCandidate || '[]');
      } catch (e) {
        existingFiltered = [];
      }

      if (!existingFiltered.includes(filterCandidateEmail)) {
        existingFiltered.push(filterCandidateEmail);
      }

      await API.graphql({
        query: updateSpotJD,
        variables: {
          input: {
            id: selectedJD.id,
            filterCandidate: JSON.stringify(existingFiltered)
          }
        }
      });

      // Create SpotCandidateStatus record
      const companyEmail = localStorage.getItem("CompanyEmailID");
      try {
        await API.graphql({
          query: createSpotCandidateStatus,
          variables: {
            input: {
              spotJdID: selectedJD.id,
              companyEmail: companyEmail,
              candidateEmail: filterCandidateEmail,
              roundStatus: 'filtered',
              isEmailsend: false,
              selectionFlag: 'filtered',
              candidateFrom: 'quick_action'
            }
          }
        });
      } catch (e) {
        console.warn('Status record may already exist');
      }

      // Call filter-candidate API for Graph DB
      await fetch(`${API_BASE_URL}/kg/spot/filter-candidate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          jd_id: selectedJD.id,
          candidate_email: filterCandidateEmail,
          round_number: 1,
          notes: filterReason || 'Filtered via Quick Actions'
        })
      });

      setActionResult({ 
        type: 'success', 
        message: `⊗ ${filterCandidateEmail} filtered successfully! Added to SpotJD and Graph DB.` 
      });

      // Clear form
      setFilterCandidateEmail('');
      setFilterReason('');

      console.log('✅ Candidate filtered:', filterCandidateEmail);
    } catch (error) {
      console.error('❌ Error filtering candidate:', error);
      setActionResult({ type: 'error', message: error.message });
    } finally {
      setIsProcessingFilter(false);
    }
  };

  // Fill candidate email from matching results
  const fillCandidateEmail = (email, action = 'select') => {
    if (action === 'select') {
      setSelectCandidateEmail(email);
    } else {
      setFilterCandidateEmail(email);
    }
  };

  //  spot gpt code start



  const [query, setQuery] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [searched, setSearched] = useState(false); // State to track if search has been done
  const chatEndRef = useRef(null); // Ref to scroll to the end of chat
  // const [chatStarted, setChatStarted] = useState(false); // Track if chat has started
  const [resumeID, setResumeID] = useState("7f8ca1de-5b03-45dc-805c-2e787362d060")
  const [spotResumeID, setSpotResumeID] = useState("")

  const handleChange = (event) => {
    setQuery(event.target.value);
  };

  // Initialize or get session for current mode/JD
  const initializeSession = async (forceNew = false) => {
    try {
      const email = localStorage.getItem("CompanyEmailID");
      if (!email) {
        console.error('No company email found');
        return null;
      }
      setCompanyEmail(email);

      const jdId = mode === 'spot' ? selectedJD?.id : null;
      
      console.log('🔄 Initializing session:', { email, mode, jdId, forceNew });
      
      const sessionInfo = await startSession(email, mode, jdId, forceNew);
      
      setCurrentSessionId(sessionInfo.sessionId);
      setMessageCount(sessionInfo.messageCount || 0);
      setRemainingMessages(sessionInfo.remainingMessages || 20);
      
      // If not a new session, load the chat history
      if (!sessionInfo.isNew && sessionInfo.sessionId) {
        await loadSessionHistory(sessionInfo.sessionId, email);
      }
      
      console.log('✅ Session initialized:', sessionInfo);
      return sessionInfo;
    } catch (error) {
      console.error('❌ Failed to initialize session:', error);
      return null;
    }
  };

  // Load session history from server
  const loadSessionHistory = async (sessionId, email) => {
    try {
      const sessionData = await getSessionMessages(sessionId, email);
      
      if (sessionData.messages && sessionData.messages.length > 0) {
        // Convert server message format to local format
        const formattedMessages = sessionData.messages.map(msg => ({
          text: msg.content,
          type: msg.role === 'user' ? 'user-message' : 'bot-message'
        }));
        setChatHistory(formattedMessages);
      }
      
      setMessageCount(sessionData.messageCount || 0);
      setRemainingMessages(sessionData.remainingMessages || 20);
    } catch (error) {
      console.error('❌ Failed to load session history:', error);
    }
  };

  // Load all sessions from server
  const loadServerSessions = async () => {
    try {
      setIsLoadingSessions(true);
      const email = localStorage.getItem("CompanyEmailID");
      if (!email) return;

      const sessions = await listSessions(email, mode === 'spot' ? 'spot' : null);
      
      // Convert to local conversation format
      const formattedConversations = sessions.map(session => ({
        id: session.session_id,
        jdId: session.jd_id,
        jdName: session.title || 'Conversation',
        topic: session.title || 'Conversation',
        createdAt: session.created_at,
        updatedAt: session.updated_at,
        messageCount: session.message_count
      }));
      
      setConversations(formattedConversations);
      console.log('✅ Loaded', formattedConversations.length, 'sessions from server');
    } catch (error) {
      console.error('❌ Failed to load sessions:', error);
    } finally {
      setIsLoadingSessions(false);
    }
  };

  const handleSubmit = async () => {
    if (!query.trim()) {
      return;
    }

    // Validate JD selection only in spot mode
    if (mode === 'spot' && !selectedJD) {
      alert('Please select a Job Description first for Spot mode');
      return;
    }

    // Check if session is at limit
    if (isAtSessionLimit(remainingMessages)) {
      setShowSessionLimitModal(true);
      return;
    }

    try {
      const userQuery = query;
      setQuery("");
      addMessage(userQuery, 'user-message');
      setIsStreaming(true);
      setStreamingContent('');
      setCurrentToolName(null);

      // Initialize session if not already done
      let sessionId = currentSessionId;
      if (!sessionId) {
        const sessionInfo = await initializeSession();
        if (!sessionInfo) {
          addMessage('Failed to start session. Please try again.', 'bot-message');
          setIsStreaming(false);
          return;
        }
        sessionId = sessionInfo.sessionId;
      }

      console.log('📤 Sending message:', { sessionId, mode, jdId: selectedJD?.id, query: userQuery });

      // Use streaming API
      await sendChatMessageStreaming(
        sessionId,
        userQuery,
        mode,
        mode === 'spot' ? selectedJD?.id : null,
        {
          onToken: (token, fullText) => {
            setStreamingContent(fullText);
          },
          onToolStart: (toolName) => {
            setCurrentToolName(toolName);
            console.log('🔧 Tool started:', toolName);
          },
          onToolEnd: (toolResult) => {
            setCurrentToolName(null);
            console.log('✅ Tool completed');
          },
          onDone: (result) => {
            console.log('🏁 Stream complete:', result);
            setIsStreaming(false);
            setStreamingContent('');
            setCurrentToolName(null);
            
            // Add the final response
            addMessage(result.response, 'bot-message');
            
            // Update session info
            setMessageCount(result.messageCount || messageCount + 1);
            setRemainingMessages(result.remainingMessages);
            
            // Update candidates list if available
            if (result.candidatesReferringTo?.length > 0) {
              setCandidatelist(result.candidatesReferringTo);
            }
          },
          onError: (error) => {
            console.error('❌ Streaming error:', error);
            setIsStreaming(false);
            setStreamingContent('');
            setCurrentToolName(null);
            addMessage(`Error: ${error}`, 'bot-message');
          },
          onSessionLimit: (limitInfo) => {
            console.warn('⚠️ Session limit reached:', limitInfo);
            setIsStreaming(false);
            setShowSessionLimitModal(true);
          }
        }
      );

      setSearched(true);
    } catch (error) {
      console.error('💥 Error sending message:', error);
      setIsStreaming(false);
      addMessage(`Error: ${error.message || 'Failed to send message. Please try again.'}`, 'bot-message');
    }
  };

  // Start a new session (force new)
  const startNewSession = async () => {
    setChatHistory([]);
    setCandidatelist([]);
    setCandidateSource([]);
    setCurrentSessionId(null);
    setMessageCount(0);
    setRemainingMessages(20);
    setShowSessionLimitModal(false);
    
    await initializeSession(true);
  };

  // Delete a conversation/session
  const deleteConversation = async (sessionId) => {
    if (window.confirm('Are you sure you want to delete this conversation?')) {
      try {
        const email = localStorage.getItem("CompanyEmailID");
        await deleteSessionAPI(sessionId, email);
        
        // Reload sessions
        await loadServerSessions();
        
        // Clear current if deleted
        if (currentSessionId === sessionId) {
          setChatHistory([]);
          setCurrentSessionId(null);
        }
      } catch (error) {
        console.error('Failed to delete conversation:', error);
      }
    }
  };

  // Load a specific conversation
  const loadConversation = async (conversation) => {
    try {
      const email = localStorage.getItem("CompanyEmailID");
      setCurrentSessionId(conversation.id);
      
      await loadSessionHistory(conversation.id, email);
      
      // Set the JD if applicable
      if (conversation.jdId) {
        const jd = availableJDs.find(j => j.id === conversation.jdId);
        if (jd) {
          setSelectedJD(jd);
        }
      }
    } catch (error) {
      console.error('Failed to load conversation:', error);
    }
  };

  const addMessage = (message, type) => {
    const newMessage = { text: message, type: type };
    setChatHistory((prevChatHistory) => [...prevChatHistory, newMessage]);
  };

  // Load conversations from server on mount
  const loadConversationsFromStorage = () => {
    // Now we load from server instead
    loadServerSessions();
  };

  // Load JDs from GraphQL
  const loadJDsFromGraphQL = async () => {
    try {
      const email = localStorage.getItem("CompanyEmailID");
      setCompanyEmail(email);
      
      if (!email) {
        console.error('No company email found in localStorage');
        setAvailableJDs([]);
        return;
      }

      // Filter JDs by company email
      const result = await API.graphql(
        graphqlOperation(listSpotJDS, {
          filter: { companyEmail: { eq: email } }
        })
      );
      
      const jds = result.data.listSpotJDS.items || [];
      setAvailableJDs(jds);
      
      console.log(`✅ Loaded ${jds.length} JDs for company: ${email}`);
      
      // Set first JD as default if available
      if (jds.length > 0 && !selectedJD) {
        setSelectedJD(jds[0]);
      } else if (jds.length === 0 && mode === 'spot') {
        console.warn('⚠️ No JDs found for this company. Spot mode requires a JD.');
      }
    } catch (error) {
      console.error('Error loading JDs:', error);
      setAvailableJDs([]);
    }
  };

  // Create new conversation/session
  const createNewConversation = async () => {
    if (mode === 'spot' && availableJDs.length === 0) {
      alert('No Job Descriptions found for your company. Please create a JD first in the Job Details page.');
      return;
    }
    
    if (mode === 'spot' && !selectedJD) {
      alert('Please select a Job Description first');
      return;
    }

    await startNewSession();
  };

  const searchConversations = () => {
    if (!searchTerm.trim()) {
      return conversations;
    }
    const lowerSearch = searchTerm.toLowerCase();
    return conversations.filter(c => 
      (c.topic && c.topic.toLowerCase().includes(lowerSearch)) ||
      (c.jdName && c.jdName.toLowerCase().includes(lowerSearch))
    );
  };

  // Video handling functions
  const openVideoModal = (videoUrl, skill, candidateName) => {
    console.log('🎬 Opening video modal:', { videoUrl, skill, candidateName });
    setCurrentVideo({ url: videoUrl, skill, candidateName });
    setIsVideoModalOpen(true);
  };

  const closeVideoModal = () => {
    console.log('🚫 Closing video modal');
    setIsVideoModalOpen(false);
    setCurrentVideo({ url: '', skill: '', candidateName: '' });
  };

  const hasVideo = (skill) => {
    // Check if skill has video (you can implement your logic here)
    // For now, return true for demonstration
    return skill && skill.trim().length > 0;
  };

  // spot gpt code end

  //  source code start

  const sourceTruncateText = (text, wordLimit) => {
    const words = text.split(' ');
    if (words.length <= wordLimit) {
      return text;
    }
    return `${words.slice(0, wordLimit).join(' ')}...`;
  };

  const handleClick = (url) => {
    window.open(url, '_blank');
  };

  // source code end

  // list candidate show code start

  const commentTruncateText = (text, wordLimit) => {
    const words = text.split(' ');
    if (words.length <= wordLimit) {
      return text;
    }
    return `${words.slice(0, wordLimit).join(' ')}...`;
  };

  // list candidate show code end

  console.log("***************Chat History********************", candidatelist)

  // Load conversations and JDs on mount
  useEffect(() => {
    const email = localStorage.getItem("CompanyEmailID");
    if (email) {
      setCompanyEmail(email);
    }
    loadConversationsFromStorage();
    loadJDsFromGraphQL();
  }, []);

  // Load sessions when mode changes (don't auto-initialize session)
  useEffect(() => {
    if (companyEmail) {
      // Just load the session list, don't auto-initialize
      loadServerSessions();
    }
  }, [mode, companyEmail]);

  // Update suggestions when mode changes
  useEffect(() => {
    setCurrentSuggestions(modeSuggestions[mode]);
  }, [mode]);

  // Handle ESC key to close video modal
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isVideoModalOpen) {
        closeVideoModal();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isVideoModalOpen]);

  // Auto-scroll to bottom on new messages
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatHistory]);

  // Process skill video links in chat messages after rendering
  useEffect(() => {
    // Find all skill video links in the chat messages
    const chatMessagesContainer = document.querySelector('.chat-messages-fullwidth');
    if (!chatMessagesContainer) return;

    const skillLinks = chatMessagesContainer.querySelectorAll('a.skill-video-link.has-video');
    
    skillLinks.forEach(link => {
      // Skip if already processed
      if (link.dataset.processed) return;
      
      const href = link.getAttribute('href');
      const skillName = link.dataset.skill || link.textContent.replace('🎥 ', '').trim();
      
      try {
        // Parse the URL to extract video URL and timestamp
        const url = new URL(href, window.location.origin);
        const videoUrl = url.origin + url.pathname;
        const timestamp = url.searchParams.get('t');
        
        console.log('🔗 Processing skill link:', { skillName, videoUrl, timestamp });
        
        // Add click handler to open video modal
        link.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log('🎬 Skill video link clicked:', { skillName, videoUrl, timestamp });
          
          // Build the video URL with timestamp if available
          let fullVideoUrl = videoUrl;
          if (timestamp) {
            fullVideoUrl = `${videoUrl}#t=${timestamp}`;
          }
          
          openVideoModal(fullVideoUrl, skillName, 'Candidate');
        });
        
        // Mark as processed
        link.dataset.processed = 'true';
        link.style.cursor = 'pointer';
        
      } catch (error) {
        console.warn('Failed to process skill link:', href, error);
      }
    });

    // Handle no-video skill links
    const noVideoLinks = chatMessagesContainer.querySelectorAll('a.skill-video-link.no-video');
    noVideoLinks.forEach(link => {
      if (link.dataset.processed) return;
      
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
      
      link.dataset.processed = 'true';
      link.style.cursor = 'default';
      link.title = link.dataset.skill + ' - No video available';
    });
  }, [chatHistory]); // Re-run when chat history changes

  return (
    <div className="SpotGPT">
      <div className="app-container spotgpt-enhanced">
        {/* Left Section */}
        <div className="left-section" style={{ marginLeft: isSidebarOpen ? '280px' : '72px', transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)' }}>
          {/* Close Button (X) in upper right */}
          <button 
            className="close-btn"
            onClick={() => navigate('/company')}
            title="Close and return to dashboard"
          >
            ✕
          </button>
          
          {/* Header with Logo - Hidden to maximize chat space */}
          {/* Logo removed to give more room for messages */}


          {/* source code start */}

          {
            candidateSource.length > 0 && (

              <div className="candidate-list2">
                <h2 className="selected-candidate-header">Source list</h2>
                <img onClick={handlezoom} src={zoom} alt="" srcset="" />
              </div>

            )
          }

          <div className="candidate-list">
            {candidateSource.map((candidate, index) => (
              <div
                className="candidate-card overflow-hidden"
                key={index}
                onClick={() => handleAddToSelectedCandidates(candidate)}
              >
                <div className="candidate-subcard overflow-hidden">
                  <div className="overflow-hidden">
                    <p
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClick(candidate);
                      }}
                      className="source-link overflow-hidden"
                    >
                      {sourceTruncateText(candidate, 4)}
                    </p>
                  </div>
                </div>
              </div>
            ))}

            {/* {candidates[4] && candidates[4].profiles && (
              <div className="view-more-card">
                <div className="profile-images">
                  {candidates[4].profiles.map((profiles, index) => (
                    <div className="profile-image" key={index}></div>
                  ))}
                </div>

                <p className="paragraph">
                  In publishing and graphic design, Lorem ipsum...
                </p>
                <a
                  onClick={() => handleViewMore(candidates[4].id)}
                  className="view-more"
                >
                  View More
                </a>
              </div>
            } */}
          </div>

          {/* source code end */}

          {
            candidatelist.length > 0 && (

              <div className="candidate-list2">
                <h2 className="selected-candidate-header">🎯 Candidate List</h2>
                <img onClick={handlezoom} src={zoom} alt="" srcset="" />
              </div>

            )
          }

          {/* candidate list data start */}
          <div className="candidate-list">
            {candidatelist.map((candidate) => (
              <div
                className="candidate-card"
                key={candidate.id}
                onClick={() => handleAddToSelectedCandidates(candidate)}
              >
                <div className="candidate-subcard">
                  <div className="candidate-avatar"></div>
                  <div className="">
                    <h6 className="font-medium ml-3 mt-2">{candidate.name}</h6>
                    {/* <p>{candidate.comments}</p> */}
                    <p className="comment-text text-gray-700">
                      {commentTruncateText(candidate.comments, 10)} {/* Display truncated comments */}
                    </p>
                  </div>
                </div>
                {/* <div className="skills bg-red-600" >
                  {candidate.skills.split(',').slice(0, 3).join(', ')}
                </div> */}

                {candidate.skills.split(',').slice(0, 3).map((skill, index) => {
                  const skillName = skill.trim();
                  const videoUrl = candidate.videos && candidate.videos[skillName];
                  
                  return (
                    <button
                      key={index}
                      type="button"
                      className={`skill-chip ${videoUrl ? 'skill-video-link has-video' : 'skill-video-link no-video'}`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (videoUrl) {
                          console.log('🎯 Skill chip clicked:', { skillName, videoUrl, candidateName: candidate.name });
                          openVideoModal(videoUrl, skillName, candidate.name);
                        }
                      }}
                      style={{ 
                        cursor: videoUrl ? 'pointer' : 'default',
                        border: 'none',
                        background: 'transparent',
                        padding: 0,
                        font: 'inherit'
                      }}
                      title={videoUrl ? `Click to watch ${skillName} video` : skillName}
                      disabled={!videoUrl}
                    >
                      {videoUrl && '🎥 '}{skillName}
                    </button>
                  );
                })}

              </div>
            ))}

            {candidatelist.length > 4 && (
              <div className="view-more-card">
                <div className="profile-images">
                  {candidatelist[4].profiles.map((profiles, index) => (
                    <div className="profile-image" key={index}>
                      <h1>{profiles.name}</h1>
                    </div>
                  ))}
                </div>

                <p className="paragraph">
                  In publishing and graphic design, Lorem ipsum...
                </p>
                <a
                  onClick={() => handleViewMore(candidates[4].id)}
                  className="view-more"
                >
                  View More
                </a>
              </div>
            )}

          </div>
          {/* candidate list data end */}

          {/* Result Section */}
          <div className="chat-main-container">
            {/* Suggestions only shown when chat is empty */}
            {chatHistory.length === 0 && (
              <div className="suggestions-container">
                <h2 className="welcome-message">
                  {mode === 'normal' && '👋 Welcome to Normal Mode'}
                  {mode === 'advanced' && '🚀 Welcome to Advanced Mode'}
                  {mode === 'spot' && '🎯 Welcome to Spot Mode'}
                </h2>
                <p className="mode-description">
                  {mode === 'normal' && 'Basic candidate and job exploration. Perfect for getting started.'}
                  {mode === 'advanced' && 'Comprehensive talent analysis with advanced analytics.'}
                  {mode === 'spot' && availableJDs.length === 0 && (
                    <span style={{ color: '#ef4444', fontWeight: 600 }}>
                      ⚠️ No Job Descriptions found for your company. Please create a JD first to use Spot Mode.
                    </span>
                  )}
                  {mode === 'spot' && availableJDs.length > 0 && 'Job-centric recruiting workflow for active recruitment.'}
                </p>
                <div className="suggestion-chips">
                  {currentSuggestions.map((suggestion, index) => (
                    <div 
                      key={index}
                      className="suggestion-chip"
                      onClick={() => {
                        setQuery(suggestion);
                        setTimeout(() => handleSubmit(), 100);
                      }}
                    >
                      {suggestion}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Chat Messages - Full width layout */}
            <div className="chat-messages-fullwidth">
              {chatHistory.map((message, index) => (
                <div key={index} className={`message-row ${message.type}`}>
                  <div className="message-bubble">
                    <span className="message-sender">
                      {message.type === 'user-message' ? 'You' : 'GetScreened AI'}
                    </span>
                    <div 
                      className="message-text markdown-content" 
                      dangerouslySetInnerHTML={{ __html: formatMarkdown(message.text) }}
                    />
                  </div>
                </div>
              ))}
              
              {/* Streaming indicator with live content */}
              {isStreaming && (
                <div className="message-row bot-message streaming">
                  <div className="message-bubble">
                    <span className="message-sender">GetScreened AI</span>
                    {currentToolName && (
                      <div className="tool-indicator">
                        <span className="tool-spinner">⚙️</span>
                        <span>Using tool: {currentToolName}...</span>
                      </div>
                    )}
                    {streamingContent ? (
                      <div 
                        className="message-text markdown-content" 
                        dangerouslySetInnerHTML={{ __html: formatMarkdown(streamingContent) }}
                      />
                    ) : (
                      <div className="typing-indicator">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    )}
                  </div>
                </div>
              )}
              
              <div ref={chatEndRef} />
            </div>
          </div>

          {/* Ask GPT Section */}
          <div className="ask-gpt">
            <div className="input-wrapper">
              
              {/* JD Selector - Only visible in Spot Mode */}
              {mode === 'spot' && (
                <div className="jd-selector-integrated">
                  <div 
                    className="jd-trigger"
                    onClick={() => setIsJDSelectorOpen(!isJDSelectorOpen)}
                    title={selectedJD ? selectedJD.jdName : "Select a Job Description"}
                  >
                    <span className="jd-badge">
                      {selectedJD ? (selectedJD.jdName || 'Selected JD') : 'Select JD'}
                    </span>
                    {isJDSelectorOpen ? <FiChevronUp /> : <FiChevronDown />}
                  </div>
                  
                  {isJDSelectorOpen && (
                    <div className="jd-dropdown-menu">
                      {availableJDs && availableJDs.length > 0 ? (
                        availableJDs.map((jd) => (
                          <div 
                            key={jd.id}
                            className={`jd-option ${selectedJD?.id === jd.id ? 'active' : ''}`}
                            onClick={() => { setSelectedJD(jd); setIsJDSelectorOpen(false); }}
                          >
                            <div className="jd-option-title">{jd.jdName || 'Untitled JD'}</div>
                          </div>
                        ))
                      ) : (
                        <div className="jd-option empty">No JDs available</div>
                      )}
                    </div>
                  )}
                </div>
              )}

              <div className="mode-selector-integrated">
                <div 
                  className="mode-trigger"
                  onClick={() => setIsModeDropdownOpen(!isModeDropdownOpen)}
                >
                  <span className={`mode-badge ${mode}`}>{mode.charAt(0).toUpperCase() + mode.slice(1)}</span>
                  {isModeDropdownOpen ? <FiChevronUp /> : <FiChevronDown />}
                </div>
                
                {isModeDropdownOpen && (
                  <div className="mode-dropdown-menu">
                    <div 
                      className={`mode-option ${mode === 'normal' ? 'active' : ''}`}
                      onClick={() => { setMode('normal'); setIsModeDropdownOpen(false); }}
                    >
                      Normal
                    </div>
                    <div 
                      className={`mode-option ${mode === 'advanced' ? 'active' : ''}`}
                      onClick={() => { setMode('advanced'); setIsModeDropdownOpen(false); }}
                    >
                      Advanced
                    </div>
                    <div 
                      className={`mode-option ${mode === 'spot' ? 'active' : ''}`}
                      onClick={() => { setMode('spot'); setIsModeDropdownOpen(false); }}
                    >
                      Spot
                    </div>
                  </div>
                )}
              </div>

              <input
                type="text"
                placeholder="Type your question here..."
                value={query}
                onChange={handleChange}
                onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
                disabled={mode === 'spot' && !selectedJD}
                required
              />
              
              {/* Quick Action Button */}
              {mode === 'spot' && (
                <button 
                  className={`quick-action-btn ${isQuickActionsOpen ? 'active' : ''}`}
                  title="Quick Actions"
                  disabled={!selectedJD}
                  onClick={() => {
                    setIsQuickActionsOpen(!isQuickActionsOpen);
                    setIsRightSectionVisible(!isRightSectionVisible); // Toggle right section visibility
                  }}
                >
                  ⚡
                </button>
              )}

              <button onClick={handleSubmit} disabled={mode === 'spot' && !selectedJD}>
                {mode === 'spot' && !selectedJD ? 'Select JD' : 'Send'}
              </button>
            </div>
          </div>

        </div>

        {/* Left Conversation Panel */}
        <div className={`left-panel ${isSidebarOpen ? 'open' : 'collapsed'}`}>
          <div className="sidebar-top-section">
            <button 
              className="menu-toggle-btn-sidebar"
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              title={isSidebarOpen ? "Collapse menu" : "Expand menu"}
            >
              <FiMenu />
            </button>
            
            <button 
              className={`new-chat-btn-sidebar ${!isSidebarOpen ? 'icon-only' : ''}`}
              onClick={createNewConversation}
              title="New Chat"
            >
              <FiPlus />
              {isSidebarOpen && <span>New chat</span>}
            </button>
          </div>

          <div className={`sidebar-content-section ${!isSidebarOpen ? 'hidden' : ''}`}>
            {isSidebarOpen && (
              <>
                <div className="sidebar-search-section">
                  <div className="search-input-wrapper">
                    <FiSearch className="search-icon" />
                    <input
                      type="text"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>

                <div className="conversations-list-section">
                  <div className="list-header">
                    Recent
                    {isLoadingSessions && <span style={{ marginLeft: '8px', fontSize: '0.75rem' }}>Loading...</span>}
                  </div>
                  <div className="conversations-list-scroll">
                    {searchConversations().map((conv) => (
                      <div
                        key={conv.id}
                        className={`conversation-item ${currentSessionId === conv.id ? 'active' : ''}`}
                        onClick={() => loadConversation(conv)}
                      >
                        <FiMessageSquare className="conv-icon" />
                        <div className="conversation-details">
                          <div className="conversation-topic">
                            {truncateText(conv.topic || 'Conversation', 25)}
                          </div>
                          {conv.messageCount && (
                            <div style={{ fontSize: '0.7rem', color: '#888' }}>
                              {conv.messageCount} messages
                            </div>
                          )}
                        </div>
                        <button 
                          className="delete-conv-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteConversation(conv.id);
                          }}
                          title="Delete conversation"
                        >
                          <FiTrash2 size={12} />
                        </button>
                      </div>
                    ))}
                    {conversations.length === 0 && !isLoadingSessions && (
                      <div style={{ padding: '16px', textAlign: 'center', color: '#888', fontSize: '0.85rem' }}>
                        No conversations yet. Start a new chat!
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="sidebar-bottom-section">
             <button className={`sidebar-nav-btn ${!isSidebarOpen ? 'icon-only' : ''}`}>
                <FiHelpCircle />
                {isSidebarOpen && <span>Help</span>}
             </button>
             <button 
                className={`sidebar-nav-btn ${!isSidebarOpen ? 'icon-only' : ''}`}
                onClick={() => setIsSettingsModalOpen(true)}
             >
                <FiSettings />
                {isSidebarOpen && <span>Settings</span>}
             </button>
          </div>
        </div>

        {/* Right Section */}
        <div className={`right-section ${isRightSectionVisible ? 'visible' : 'hidden'}`}>
          {isRightSectionVisible && (
            <>
              {isQuickActionsOpen ? (
                <div className="quick-actions-panel">
                  <div className="sidebar-header">
                    <h3>Quick Actions</h3>
                    <button 
                      className="close-btn-small" 
                      onClick={() => {
                        setIsQuickActionsOpen(false);
                        setIsRightSectionVisible(false);
                      }}
                    >
                      ×
                    </button>
                  </div>
                  
                  <div className="quick-actions-content">
                    {/* Action Result Message */}
                    {actionResult.message && (
                      <div className={`action-result ${actionResult.type}`}>
                        {actionResult.message}
                      </div>
                    )}

                    {/* Current JD Info */}
                    {selectedJD && (
                      <div className="current-jd-info">
                        <span className="jd-label">Selected JD:</span>
                        <span className="jd-name">{selectedJD.jdName}</span>
                      </div>
                    )}
                    {!selectedJD && (
                      <div className="action-result error">
                        ⚠️ Please select a JD from the dropdown above to use Quick Actions
                      </div>
                    )}

                    {/* Run Matching Engine Action */}
                    <div className="action-card">
                      <div className="action-header">
                        <span className="action-icon">⚡</span>
                        <h4>Run Matching Engine</h4>
                      </div>
                      <div className="action-body">
                        <p style={{ fontSize: '0.85rem', color: '#888', marginBottom: '12px' }}>
                          Find candidates matching the job requirements.
                        </p>
                        
                        {/* Auto-filter Toggle */}
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: '8px', 
                          marginBottom: '12px',
                          padding: '8px',
                          backgroundColor: 'rgba(153, 0, 255, 0.05)',
                          borderRadius: '8px'
                        }}>
                          <input
                            type="checkbox"
                            id="autoFilterToggle"
                            checked={autoFilterEnabled}
                            onChange={(e) => setAutoFilterEnabled(e.target.checked)}
                            style={{ accentColor: '#9900ff', width: '16px', height: '16px' }}
                          />
                          <label htmlFor="autoFilterToggle" style={{ fontSize: '0.85rem', cursor: 'pointer' }}>
                            Auto-filter on match (default: off)
                          </label>
                        </div>

                        <button 
                          className="action-btn matching"
                          onClick={runMatchingEngine}
                          disabled={isRunningMatching || !selectedJD}
                          style={{
                            backgroundColor: isRunningMatching ? '#666' : '#9900ff',
                            cursor: isRunningMatching || !selectedJD ? 'not-allowed' : 'pointer',
                            opacity: !selectedJD ? 0.5 : 1
                          }}
                        >
                          {isRunningMatching ? '⏳ Running...' : '⚡ Run Matching Engine'}
                        </button>
                        
                        {matchingResult && (
                          <div className="matching-results" style={{ marginTop: '12px' }}>
                            <div style={{ 
                              padding: '10px', 
                              backgroundColor: 'rgba(153, 0, 255, 0.1)', 
                              borderRadius: '8px',
                              fontSize: '0.9rem'
                            }}>
                              <strong>Results:</strong> {matchingResult.total} candidates found 
                              ({matchingResult.qualified} qualified)
                              {selectedMatchingCandidates.length > 0 && (
                                <span style={{ marginLeft: '10px', color: '#9900ff' }}>
                                  | {selectedMatchingCandidates.length} selected
                                </span>
                              )}
                            </div>
                            
                            {/* Selection controls */}
                            {matchedCandidatesFromEngine.length > 0 && (
                              <div style={{ 
                                display: 'flex', 
                                gap: '8px', 
                                marginTop: '10px',
                                flexWrap: 'wrap'
                              }}>
                                <button
                                  onClick={selectAllMatchingCandidates}
                                  style={{
                                    padding: '6px 12px',
                                    fontSize: '0.75rem',
                                    backgroundColor: 'rgba(153, 0, 255, 0.1)',
                                    color: '#9900ff',
                                    border: '1px solid rgba(153, 0, 255, 0.3)',
                                    borderRadius: '6px',
                                    cursor: 'pointer'
                                  }}
                                >
                                  Select All
                                </button>
                                <button
                                  onClick={deselectAllMatchingCandidates}
                                  style={{
                                    padding: '6px 12px',
                                    fontSize: '0.75rem',
                                    backgroundColor: 'rgba(100, 100, 100, 0.1)',
                                    color: '#888',
                                    border: '1px solid rgba(100, 100, 100, 0.3)',
                                    borderRadius: '6px',
                                    cursor: 'pointer'
                                  }}
                                >
                                  Deselect All
                                </button>
                              </div>
                            )}
                            
                            {/* Matched candidates list with checkboxes */}
                            {matchedCandidatesFromEngine.length > 0 && (
                              <div className="matched-candidates-list" style={{ marginTop: '10px', maxHeight: '250px', overflowY: 'auto' }}>
                                {matchedCandidatesFromEngine.map((candidate, idx) => {
                                  const email = candidate.email || candidate.candidate_email;
                                  const isChecked = selectedMatchingCandidates.some(c => (c.email || c.candidate_email) === email);
                                  return (
                                    <div 
                                      key={idx}
                                      onClick={() => toggleMatchingCandidateSelection(candidate)}
                                      style={{
                                        padding: '10px',
                                        backgroundColor: isChecked ? 'rgba(153, 0, 255, 0.15)' : 'rgba(255,255,255,0.05)',
                                        borderRadius: '6px',
                                        marginBottom: '6px',
                                        cursor: 'pointer',
                                        border: isChecked ? '1px solid rgba(153, 0, 255, 0.4)' : '1px solid transparent',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '10px'
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={isChecked}
                                        onChange={() => toggleMatchingCandidateSelection(candidate)}
                                        onClick={(e) => e.stopPropagation()}
                                        style={{ accentColor: '#9900ff', marginTop: '3px' }}
                                      />
                                      <div style={{ flex: 1 }}>
                                        <div style={{ fontWeight: 500, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                          <span>{candidate.full_name || candidate.name || 'Unknown'}</span>
                                          <div style={{ display: 'flex', gap: '4px' }}>
                                            {candidate.isFiltered && (
                                              <span style={{ fontSize: '0.65rem', padding: '2px 6px', backgroundColor: 'rgba(249, 115, 22, 0.2)', color: '#f97316', borderRadius: '4px' }}>FILTERED</span>
                                            )}
                                            {candidate.isSelected && (
                                              <span style={{ fontSize: '0.65rem', padding: '2px 6px', backgroundColor: 'rgba(34, 197, 94, 0.2)', color: '#22c55e', borderRadius: '4px' }}>SELECTED</span>
                                            )}
                                          </div>
                                        </div>
                                        <div style={{ fontSize: '0.8rem', color: '#888' }}>{email}</div>
                                        {candidate.overall_score && (
                                          <div style={{ fontSize: '0.75rem', color: '#9900ff' }}>
                                            Score: {(candidate.overall_score * 100).toFixed(1)}%
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                            
                            {/* Action buttons for selected candidates */}
                            {selectedMatchingCandidates.length > 0 && (
                              <div style={{ 
                                display: 'flex', 
                                gap: '8px', 
                                marginTop: '12px',
                                flexWrap: 'wrap'
                              }}>
                                {/* Filter button - only show when auto-filter is OFF */}
                                {!autoFilterEnabled && (
                                  <button
                                    onClick={filterSelectedMatchingCandidates}
                                    disabled={isRunningMatching}
                                    style={{
                                      padding: '8px 16px',
                                      fontSize: '0.8rem',
                                      backgroundColor: '#f97316',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '8px',
                                      cursor: isRunningMatching ? 'not-allowed' : 'pointer',
                                      opacity: isRunningMatching ? 0.6 : 1
                                    }}
                                  >
                                    ⊗ Filter Selected ({selectedMatchingCandidates.length})
                                  </button>
                                )}
                                <button
                                  onClick={selectMatchingCandidatesForScreening}
                                  disabled={isRunningMatching}
                                  style={{
                                    padding: '8px 16px',
                                    fontSize: '0.8rem',
                                    backgroundColor: '#22c55e',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: isRunningMatching ? 'not-allowed' : 'pointer',
                                    opacity: isRunningMatching ? 0.6 : 1
                                  }}
                                >
                                  📧 Private Screen ({selectedMatchingCandidates.length})
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Private Screen Candidate Action */}
                    <div className="action-card">
                      <div className="action-header">
                        <span className="action-icon">📧</span>
                        <h4>Private Screen Candidate</h4>
                      </div>
                      <p style={{ fontSize: '0.8rem', color: '#888', padding: '0 12px', marginBottom: '8px' }}>
                        Send private screening invitation to candidate. They will be added to SpotJD and Knowledge Graph for tracking.
                      </p>
                      <div className="action-body">
                        <div className="form-group">
                          <label>Candidate Email</label>
                          <input 
                            type="email" 
                            placeholder="candidate@example.com"
                            value={selectCandidateEmail}
                            onChange={(e) => setSelectCandidateEmail(e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <label>Round Number</label>
                          <input 
                            type="number" 
                            value={selectRoundNumber}
                            onChange={(e) => setSelectRoundNumber(parseInt(e.target.value) || 1)}
                            min="1" 
                          />
                        </div>
                        <div className="form-group">
                          <label>Notes</label>
                          <textarea 
                            placeholder="Add selection notes..."
                            value={selectNotes}
                            onChange={(e) => setSelectNotes(e.target.value)}
                          ></textarea>
                        </div>
                        <button 
                          className="action-btn primary"
                          onClick={handleSelectCandidate}
                          disabled={isProcessingSelect || !selectedJD}
                          style={{
                            opacity: isProcessingSelect || !selectedJD ? 0.6 : 1,
                            cursor: isProcessingSelect || !selectedJD ? 'not-allowed' : 'pointer'
                          }}
                        >
                          {isProcessingSelect ? '⏳ Processing...' : '📧 Send Private Screening'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <h2>
                    {" "}
                    <span className="icon">✨</span> Final Selected Candidates
                  </h2>
                  <div className="right-candidate-list">
                    {selectedCandidates.map((candidate) => (
                      <div className="candidate-card2 overflow-hidden" key={candidate.id}>
                        <span
                          className="remove-icon"
                          onClick={() => handleRemoveCandidate(candidate)}
                        >
                          ✖
                        </span>
                        <div className="candidate-subcard">
                          <div className="candidate-avatar2"></div>
                          <div>
                            <h3 className="name text-black">{candidate.name}</h3>
                            <p className="discription text-black">{candidate.comments}</p>
                          </div>
                        </div>
                        <div className="skills">
                          {candidate.skills.split(',').slice(0, 3).join(', ')}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Send Mail to Candidate Button */}
                  <div className="send-mail">
                    <button className="send-mail-button">
                      Send Mail to Candidate
                    </button>
                  </div>
                </>
              )}
            </>
          )}
        </div>

        {/* Video Modal */}
        {isVideoModalOpen && (
          <div className="video-modal" onClick={closeVideoModal}>
            <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="video-header">
                <h2>{currentVideo.skill} - Skill Evidence</h2>
                <button className="video-close" onClick={closeVideoModal}>×</button>
              </div>
              <div className="video-container">
                <video controls autoPlay key={currentVideo.url}>
                  <source src={currentVideo.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="video-info">
                <p><strong>Candidate:</strong> {currentVideo.candidateName}</p>
                <p><strong>Skill:</strong> {currentVideo.skill}</p>
                <p><strong>Evidence:</strong> Video demonstration from interview</p>
              </div>
            </div>
          </div>
        )}

        {/* Session Limit Modal */}
        {showSessionLimitModal && (
          <div className="video-modal" onClick={() => setShowSessionLimitModal(false)}>
            <div className="video-modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '450px' }}>
              <div className="video-header" style={{ backgroundColor: '#f97316' }}>
                <h2>Session Limit Reached</h2>
                <button className="video-close" onClick={() => setShowSessionLimitModal(false)}>×</button>
              </div>
              <div style={{ padding: '24px', textAlign: 'center' }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
                <p style={{ fontSize: '1rem', color: '#333', marginBottom: '16px' }}>
                  You've reached the maximum of <strong>20 messages</strong> for this session.
                </p>
                <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '24px' }}>
                  Start a new conversation to continue chatting. Your current session history will be saved.
                </p>
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                  <button
                    onClick={() => setShowSessionLimitModal(false)}
                    style={{
                      padding: '10px 20px',
                      backgroundColor: '#f3f4f6',
                      border: '1px solid #d1d5db',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '0.9rem'
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={startNewSession}
                    style={{
                      padding: '10px 20px',
                      backgroundColor: '#9900ff',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '0.9rem'
                    }}
                  >
                    <FiRefreshCw style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                    Start New Conversation
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* MCP Settings Modal */}
        <MCPSettingsModal
          isOpen={isSettingsModalOpen}
          onClose={() => setIsSettingsModalOpen(false)}
          companyId={localStorage.getItem("CompanyProfileID") || localStorage.getItem("companyId")}
          companyEmail={localStorage.getItem("CompanyEmailID")}
          availableJDs={availableJDs}
        />
      </div>
    </div>
  );
}

export default SpotGPT;
